export default __webpack_public_path__ + "static/media/screen.e68c2377.png";